__turbopack_context__.v({
  "card": "mochi-card-module-scss-module__FDIanW__card",
});
